import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { DropDownComp } from "./components/newWorkSpace/DropDown";
import { httpService } from "../../base/services/httpService.service";
import { LocalStorageService } from "../../base/services/local-storage.service";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../auth/userRoles.enum";
import ReactivatedModal from "./components/ReactivatedModal/ReactivatedModal";
import WorkspaceSelection from "./components/workspaceSelection/WorkspaceSelection";
import { withErrorBoundary } from "../../components/ErrorBoundary/withErrorBoundary";
import ArchivedItemsModal from "../../components/Archive/ArchivedItemsModal";
import { archiveWithNotice, isArchiveEnabled } from "../../components/Archive/archiveApi";
import { EntityTypeEnum } from "../../utils/enums";

import "./style.scss";

function Index() {
   const userDetails = JSON.parse(localStorage.getItem("roles"));
   const [isLoading, setIsLoading] = useState(false);
   const [workSpaces, setWorkSpaces] = useState([]);
   const [isArchivedOpen, setIsArchivedOpen] = useState(false);
   const navigate = useNavigate();

   const loadWorkspaces = useCallback(() => {
      setIsLoading(true);
      httpService.get("/Workspaces/getMyWorkspaces", (res) => {
         setWorkSpaces(res.data);
         setIsLoading(false);
      });
   }, []);

   useEffect(() => {
      loadWorkspaces();
   }, [loadWorkspaces]);

   const [isMounted, setIsMounted] = useState(true);
   console.log(isMounted);

   useEffect(() => {
      return () => {
         setIsMounted(false);
      };
   }, []);

   const handleDelete = (id) => {
      httpService
         .post("/Workspaces/delete", {
            id: id
         })
         .then(() => {
            setWorkSpaces((prevWorkSpaces) =>
               prevWorkSpaces.filter((workspace) => workspace.id !== id)
            );
         });
   };

   const archiveWorkspace = async (id) => {
      if (await archiveWithNotice(EntityTypeEnum.Workspace, id)) loadWorkspaces();
   };

   const enterWorkspace = (workspaceId) => {
      LocalStorageService.setItem("currentWorkspaceId", workspaceId);
      LocalStorageService.removeItem("currentProjectID");
      if (AuthService.isAuthorized([UserRolesEnum.DataCollector])) {
         navigate("/tasks");
         return;
      }
      navigate("/project-selection");
   };

   useEffect(() => {
      LocalStorageService.removeItem("currentWorkspaceId");
      LocalStorageService.removeItem("currentProjectID");
   }, []);

   const canManageWorkspaces = AuthService.isAuthorized([
      UserRolesEnum.SuperAdmin,
      UserRolesEnum.Organization,
      UserRolesEnum.AdminOfOrganization,
      UserRolesEnum.SeniorProjectManager
   ]);
   const canArchive = canManageWorkspaces && isArchiveEnabled();

   return (
      <>
         <WorkspaceSelection
            userName={AuthService.getUser()?.fullName}
            roleLabel={userDetails?.[0]?.name?.replace(/([a-z])([A-Z])/g, "$1 $2")}
            workspaces={workSpaces || []}
            isLoading={isLoading}
            onEnterWorkspace={enterWorkspace}
            canCreateWorkspace={canManageWorkspaces}
            onWorkspaceSaved={loadWorkspaces}
            onShowArchived={canArchive ? () => setIsArchivedOpen(true) : undefined}
            renderWorkspaceActions={
               canManageWorkspaces
                  ? (workspace, { onEdit }) => (
                       <DropDownComp
                          handleDelete={handleDelete}
                          id={workspace.id}
                          onEdit={onEdit}
                          onArchive={canArchive ? archiveWorkspace : undefined}
                       />
                    )
                  : null
            }
         />
         {canArchive && (
            <ArchivedItemsModal
               entityType={EntityTypeEnum.Workspace}
               isModalOpen={isArchivedOpen}
               onClose={() => setIsArchivedOpen(false)}
               onRestored={loadWorkspaces}
            />
         )}
         <ReactivatedModal />
      </>
   );
}

export default withErrorBoundary(Index);
